import React from 'react';
import { Container } from 'react-bootstrap';

function Footer() {
    return (
        <footer className="py-4 bg-light mt-5 border-top">
            <Container className="text-center" data-aos="fade-up">
                <p className="mb-1 text-muted">
                    Contactos: hberrospir1@upao.edu.pe   |  svelasquezr1@upao.edu.pe
                </p>
                <p className="mb-1 text-muted">
                    &copy; {new Date().getFullYear()} EduDrive.
                </p>
                <p className="small text-muted">
                    Proyecto académico. Todos los derechos reservados.
                </p>
            </Container>
        </footer>
    );
}

export default Footer;
